import PropTypes from 'prop-types';

const ALL_TYPE_DOSSIERS = [
  { id: 'OeuvreArchitecture', label: 'Architecture' },
  { id: 'OeuvreObjet', label: 'Objet' },
  { id: 'Mobilier', label: 'Mobilier' },
  { id: 'Collectif', label: 'Collectif' },
  { id: 'Thematique', label: 'Thématique' },
  { id: 'AireEtude', label: "Aire d'étude" },
  { id: 'Operation', label: 'Opération' },
];

const TypeDossierField = ({ typeDossier, checked, onChange }) => (
  <label>
    <input
      type="checkbox"
      name="typeDossier"
      className="type-dossier"
      value={typeDossier.id}
      checked={checked}
      onChange={onChange}
    />
    {typeDossier.label}
  </label>
);
TypeDossierField.propTypes = {
  typeDossier: PropTypes.object,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

const TypeDossiersForm = ({ typeDossiers, onChange }) => (
  <div className="expert-form-type-dossiers">
    {ALL_TYPE_DOSSIERS.map((typeDossier) => (
      <TypeDossierField
        key={typeDossier.id}
        typeDossier={typeDossier}
        checked={(typeDossiers ?? []).includes(typeDossier.id)}
        onChange={(event) => onChange?.(typeDossier.id, event.target.checked)}
      />
    ))}
  </div>
);
TypeDossiersForm.propTypes = {
  typeDossiers: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default TypeDossiersForm;
